import ListingCreate from './ListingCreate';

export default ListingCreate;
